[
  { "date": "2023-12-25", "holidayName": "Juledag" },
  { "date": "2023-12-26", "holidayName": "Anden juledag" },
  { "date": "2024-01-01", "holidayName": "Nytårsdag" },
  { "date": "2024-03-24", "holidayName": "Palmesøndag" },
  { "date": "2024-03-28", "holidayName": "Skærtorsdag" },
  { "date": "2024-03-29", "holidayName": "Langfredag" },
  { "date": "2024-03-31", "holidayName": "Påskedag" },
  { "date": "2024-04-01", "holidayName": "Anden påskedag" },
  { "date": "2024-04-26", "holidayName": "Store bededag" },
  { "date": "2024-05-09", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2024-05-19", "holidayName": "Pinsedag" },
  { "date": "2024-05-20", "holidayName": "Anden pinsedag" },
  { "date": "2024-12-25", "holidayName": "Juledag" },
  { "date": "2024-12-26", "holidayName": "Anden juledag" },
  { "date": "2025-01-01", "holidayName": "Nytårsdag" },
  { "date": "2025-04-13", "holidayName": "Palmesøndag" },
  { "date": "2025-04-17", "holidayName": "Skærtorsdag" },
  { "date": "2025-04-18", "holidayName": "Langfredag" },
  { "date": "2025-04-20", "holidayName": "Påskedag" },
  { "date": "2025-04-21", "holidayName": "Anden påskedag" },
  { "date": "2025-05-16", "holidayName": "Store bededag" },
  { "date": "2025-05-29", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2025-06-08", "holidayName": "Pinsedag" },
  { "date": "2025-06-09", "holidayName": "Anden pinsedag" },
  { "date": "2025-12-25", "holidayName": "Juledag" },
  { "date": "2025-12-26", "holidayName": "Anden juledag" },
  { "date": "2026-01-01", "holidayName": "Nytårsdag" },
  { "date": "2026-03-29", "holidayName": "Palmesøndag" },
  { "date": "2026-04-02", "holidayName": "Skærtorsdag" },
  { "date": "2026-04-03", "holidayName": "Langfredag" },
  { "date": "2026-04-05", "holidayName": "Påskedag" },
  { "date": "2026-04-06", "holidayName": "Anden påskedag" },
  { "date": "2026-05-01", "holidayName": "Store bededag" },
  { "date": "2026-05-14", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2026-05-24", "holidayName": "Pinsedag" },
  { "date": "2026-05-25", "holidayName": "Anden pinsedag" },
  { "date": "2026-12-25", "holidayName": "Juledag" },
  { "date": "2026-12-26", "holidayName": "Anden juledag" },
  { "date": "2027-01-01", "holidayName": "Nytårsdag" },
  { "date": "2027-03-21", "holidayName": "Palmesøndag" },
  { "date": "2027-03-25", "holidayName": "Skærtorsdag" },
  { "date": "2027-03-26", "holidayName": "Langfredag" },
  { "date": "2027-03-28", "holidayName": "Påskedag" },
  { "date": "2027-03-29", "holidayName": "Anden påskedag" },
  { "date": "2027-04-23", "holidayName": "Store bededag" },
  { "date": "2027-05-06", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2027-05-16", "holidayName": "Pinsedag" },
  { "date": "2027-05-17", "holidayName": "Anden pinsedag" },
  { "date": "2027-12-25", "holidayName": "Juledag" },
  { "date": "2027-12-26", "holidayName": "Anden juledag" },
  { "date": "2028-01-01", "holidayName": "Nytårsdag" },
  { "date": "2028-04-09", "holidayName": "Palmesøndag" },
  { "date": "2028-04-13", "holidayName": "Skærtorsdag" },
  { "date": "2028-04-14", "holidayName": "Langfredag" },
  { "date": "2028-04-16", "holidayName": "Påskedag" },
  { "date": "2028-04-17", "holidayName": "Anden påskedag" },
  { "date": "2028-05-12", "holidayName": "Store bededag" },
  { "date": "2028-05-25", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2028-06-04", "holidayName": "Pinsedag" },
  { "date": "2028-06-05", "holidayName": "Anden pinsedag" },
  { "date": "2028-12-25", "holidayName": "Juledag" },
  { "date": "2028-12-26", "holidayName": "Anden juledag" },
  { "date": "2029-01-01", "holidayName": "Nytårsdag" },
  { "date": "2029-03-25", "holidayName": "Palmesøndag" },
  { "date": "2029-03-29", "holidayName": "Skærtorsdag" },
  { "date": "2029-03-30", "holidayName": "Langfredag" },
  { "date": "2029-04-01", "holidayName": "Påskedag" },
  { "date": "2029-04-02", "holidayName": "Anden påskedag" },
  { "date": "2029-04-27", "holidayName": "Store bededag" },
  { "date": "2029-05-10", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2029-05-20", "holidayName": "Pinsedag" },
  { "date": "2029-05-21", "holidayName": "Anden pinsedag" },
  { "date": "2029-12-25", "holidayName": "Juledag" },
  { "date": "2029-12-26", "holidayName": "Anden juledag" },
  { "date": "2030-01-01", "holidayName": "Nytårsdag" },
  { "date": "2030-04-14", "holidayName": "Palmesøndag" },
  { "date": "2030-04-18", "holidayName": "Skærtorsdag" },
  { "date": "2030-04-19", "holidayName": "Langfredag" },
  { "date": "2030-04-21", "holidayName": "Påskedag" },
  { "date": "2030-04-22", "holidayName": "Anden påskedag" },
  { "date": "2030-05-17", "holidayName": "Store bededag" },
  { "date": "2030-05-30", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2030-06-09", "holidayName": "Pinsedag" },
  { "date": "2030-06-10", "holidayName": "Anden pinsedag" },
  { "date": "2030-12-25", "holidayName": "Juledag" },
  { "date": "2030-12-26", "holidayName": "Anden juledag" },
  { "date": "2031-01-01", "holidayName": "Nytårsdag" },
  { "date": "2031-04-06", "holidayName": "Palmesøndag" },
  { "date": "2031-04-10", "holidayName": "Skærtorsdag" },
  { "date": "2031-04-11", "holidayName": "Langfredag" },
  { "date": "2031-04-13", "holidayName": "Påskedag" },
  { "date": "2031-04-14", "holidayName": "Anden påskedag" },
  { "date": "2031-05-09", "holidayName": "Store bededag" },
  { "date": "2031-05-22", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2031-06-01", "holidayName": "Pinsedag" },
  { "date": "2031-06-02", "holidayName": "Anden pinsedag" },
  { "date": "2031-12-25", "holidayName": "Juledag" },
  { "date": "2031-12-26", "holidayName": "Anden juledag" },
  { "date": "2032-01-01", "holidayName": "Nytårsdag" },
  { "date": "2032-03-21", "holidayName": "Palmesøndag" },
  { "date": "2032-03-25", "holidayName": "Skærtorsdag" },
  { "date": "2032-03-26", "holidayName": "Langfredag" },
  { "date": "2032-03-28", "holidayName": "Påskedag" },
  { "date": "2032-03-29", "holidayName": "Anden påskedag" },
  { "date": "2032-04-23", "holidayName": "Store bededag" },
  { "date": "2032-05-06", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2032-05-16", "holidayName": "Pinsedag" },
  { "date": "2032-05-17", "holidayName": "Anden pinsedag" },
  { "date": "2032-12-25", "holidayName": "Juledag" },
  { "date": "2032-12-26", "holidayName": "Anden juledag" },
  { "date": "2033-01-01", "holidayName": "Nytårsdag" },
  { "date": "2033-04-10", "holidayName": "Palmesøndag" },
  { "date": "2033-04-14", "holidayName": "Skærtorsdag" },
  { "date": "2033-04-15", "holidayName": "Langfredag" },
  { "date": "2033-04-17", "holidayName": "Påskedag" },
  { "date": "2033-04-18", "holidayName": "Anden påskedag" },
  { "date": "2033-05-13", "holidayName": "Store bededag" },
  { "date": "2033-05-26", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2033-06-05", "holidayName": "Pinsedag" },
  { "date": "2033-06-06", "holidayName": "Anden pinsedag" }
]
